module.exports = __webpack_public_path__ + "media/honey-icons/icon-signal-2bar-c8f58520.svg";